module.exports = __webpack_public_path__ + "img/itx-file-type-ppt.2c0ceb9c.svg";